import HttpRequest from '@/libs/axios'

// const baseUrl = 'https://dev.tutordata.cn'
const baseUrl = process.env.NODE_ENV === 'development' ? 'https://dev.tutordata.cn' : '';

const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/api/index.js